export const senha = (senha) => {
    if(senha.length < 1){
            return { value: false, mess: "Erro! Campo senha obrigatório" }
        }
        if(senha.length < 5){
            return { value: false, mess: "Erro! Campo senha no mínimo 8 caracteres" }
        }else{
            return {value: true }
        } 
};